export class ListItem {
  id: number;
  code: string;
  label: string;
}

export class Country extends ListItem {
  languagesGui: Language[];
  languagesPdf: Language[];
  // pour la customization de l'interface selon le pays du distributeur
  hasRpg: boolean;
  bbox: any;
  geocoderCodes: string;
  telCountryCode: string;
}

export class Language extends ListItem {}

export class Specy extends ListItem {}

export class Soil extends ListItem {}

export class SoilDepth extends ListItem {}

export class PreviousCrop extends ListItem {
  fallow: boolean;
  cereal: boolean;
}

export class FallowAge extends ListItem {}

export class FallowType extends ListItem {}

export class CerealOutcome extends ListItem {}

export class Variety extends ListItem {
  specy: Specy;
}

export class Destination extends ListItem {
  specy: Specy;
}

export class Tool extends ListItem {
  species: Specy[];
}
